import axios from "axios";
import Config from "src/config";

const v1_actionMessengerCapacidades = (clienteId, { canalId }) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/capacidades`,
        params: { canalId }
    });
};

export default v1_actionMessengerCapacidades;
